import { createFileRoute } from "@tanstack/react-router";

import { defineHead } from "../-common";
import { PROTECTED_ROUTE_OPTIONS } from "../../-common";

import { Protected } from "~/entities/auth";
import { Tk } from "~/shared/i18n";

export const Route = createFileRoute("/{-$locale}/admin-panel/users")({
  head: defineHead({
    titleT: {
      key: Tk.USER,
      options: {
        count: 2,
      },
    },
  }),
  component: Protected(PROTECTED_ROUTE_OPTIONS.ADMIN_PANEL_USERS),
});
